import React, {useEffect} from 'react';
import {useFirebaseAuthUserStore} from '../../stores/FirebaseAuthUserStore';
import {useFirestoreUserStore} from '../../stores/FirestoreUserStore';
import {useNewsStore} from '../../stores/NewsStore';
import {usePostsStore} from '../../stores/PostsStore';
import {useUsersStore} from '../../stores/UsersStore';

export const HandleCypress = () => {
	useEffect(() => {
		if (window.Cypress) {
			// @ts-expect-error: Should expect Zustand
			window.useFirebaseAuthUserStore = useFirebaseAuthUserStore;
			// @ts-expect-error: Should expect Zustand
			window.useFirestoreUserStore = useFirestoreUserStore;
			// @ts-expect-error: Should expect Zustand
			window.useNewsStore = useNewsStore;
			// @ts-expect-error: Should expect Zustand
			window.usePostsStore = usePostsStore;
			// @ts-expect-error: Should expect Zustand
			window.useUsersStore = useUsersStore;
		}
	}, []);

	return <></>;
};
